export default "__VITE_ASSET__BPYg3dj2__"